module.exports = "<div class='container-fluid'>\r\n    <div class='body-navigation'>\r\n        <app-nav-menu></app-nav-menu>\r\n    </div>\r\n    <div class='body-content'>\r\n        <router-outlet></router-outlet>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/main/layout.main.component.html
// module id = ./src/app/layouts/main/layout.main.component.html
// module chunks = main